import {
    PROFILE_SPECIALCASES_FETCH,
    PROFILE_SPECIALCASES_IS_FETCING,
    PROFILE_SPECIALCASES_API,
    PROFILE_SPECIALCASE_EDIT
} from 'constants/profileSpecialCases'

import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

export const profileSpecialCaseSave = (profileId, data) => (dispatch, state) => {
    let action;
    if (data.profileSpecialCaseId)
        action = put;
    else
        action = post;
    dispatch(profileSpecialCasesIsFetching(true))
    return action(`${PROFILE_SPECIALCASES_API}/${profileId}/specialcases`, data)
        .finally(e => dispatch(profileSpecialCasesIsFetching(false)))
}


export const profileSpecialCaseFetch = (id) => (dispatch, state) => {
        dispatch(profileSpecialCasesIsFetching(true));
        return get(PROFILE_SPECIALCASES_API + '/' + id)
            .finally(e => dispatch(profileSpecialCasesIsFetching(false)))
}

export const profileSpecialCasesFetch = (profileId) => (dispatch, state) => {
    dispatch(profileSpecialCasesIsFetching(true))
    return get(`${PROFILE_SPECIALCASES_API}/${profileId}/specialcases`)
        .then((e) => {
            dispatch(profileSpecialCasesFetched(e))
            return e
        })
        .finally(e => dispatch(profileSpecialCasesIsFetching(false)))
}

//this fetch special cases without updating redux store
export const profileSpecialCasesFetchHelper = (profileId) => (dispatch, state) => {
	dispatch(profileSpecialCasesIsFetching(true))
	return get(`${PROFILE_SPECIALCASES_API}/${profileId}/specialcases`)
			.then((e) => {
					return e
			})
			.finally(e => dispatch(profileSpecialCasesIsFetching(false)))
}

export const profileSpecialCaseRemove = (profileId, id) => (dispatch, state) => {
    dispatch(profileSpecialCasesIsFetching(true))
    return remove(`${PROFILE_SPECIALCASES_API}/${profileId}/specialcases/${id}`)
        .finally(e => dispatch(profileSpecialCasesIsFetching(false)))
}

export const profileSpecialCasesFetched = (payload) => ({ type: PROFILE_SPECIALCASES_FETCH, payload: payload })
export const profileSpecialCasesIsFetching = (payload) => ({ type: PROFILE_SPECIALCASES_IS_FETCING, payload: payload })
export const profileSpecialCaseEdit = (id, data) => ({ type: PROFILE_SPECIALCASE_EDIT, payload: data })



// WEBPACK FOOTER //
// ./src/actions/profileSpecialCases.js